var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g, _path39, _path40, _g2, _path41, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2NdStepGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 300,
    viewBox: "0 0 553 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H170.245V300H9.99998C4.47714 300 0 295.523 0 290V10Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 11.9633C11.043 10.9468 11.867 10.1228 12.8835 10.1228H157.362C158.378 10.1228 159.202 10.9468 159.202 11.9633V45.0921C159.202 46.1086 158.378 46.9326 157.362 46.9326H12.8835C11.867 46.9326 11.043 46.1086 11.043 45.0921V11.9633Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 98.4665C11.043 97.45 11.867 96.626 12.8835 96.626H157.362C158.378 96.626 159.202 97.45 159.202 98.4665V131.595C159.202 132.612 158.378 133.436 157.362 133.436H12.8835C11.867 133.436 11.043 132.612 11.043 131.595V98.4665Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 55.2148C11.043 54.1983 11.867 53.3743 12.8835 53.3743H157.362C158.378 53.3743 159.202 54.1983 159.202 55.2148V88.3436C159.202 89.3601 158.378 90.1841 157.362 90.1841H12.8835C11.867 90.1841 11.043 89.3601 11.043 88.3436V55.2148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 141.718C11.043 140.701 11.867 139.877 12.8835 139.877H157.362C158.378 139.877 159.202 140.701 159.202 141.718V174.847C159.202 175.863 158.378 176.687 157.362 176.687H12.8835C11.867 176.687 11.043 175.863 11.043 174.847V141.718Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 184.969C11.043 183.953 11.867 183.129 12.8835 183.129H157.362C158.378 183.129 159.202 183.953 159.202 184.969V218.098C159.202 219.115 158.378 219.939 157.362 219.939H12.8835C11.867 219.939 11.043 219.115 11.043 218.098V184.969Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 228.221C11.043 227.204 11.867 226.38 12.8835 226.38H157.362C158.378 226.38 159.202 227.204 159.202 228.221V261.35C159.202 262.366 158.378 263.19 157.362 263.19H12.8835C11.867 263.19 11.043 262.366 11.043 261.35V228.221Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 271.473C11.043 270.456 11.867 269.632 12.8835 269.632H157.362C158.378 269.632 159.202 270.456 159.202 271.473V298.16C159.202 299.176 158.378 300 157.362 300H12.8835C11.867 300 11.043 299.176 11.043 298.16V271.473Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.209 15.6443C182.209 12.5948 184.681 10.1228 187.73 10.1228H307.362C310.412 10.1228 312.884 12.5949 312.884 15.6443V114.111C312.884 117.16 310.412 119.632 307.362 119.632H187.73C184.681 119.632 182.209 117.16 182.209 114.111V15.6443Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4541 71.779C52.4541 70.2543 53.6901 69.0183 55.2148 69.0183H83.7424C85.2672 69.0183 86.5032 70.2543 86.5032 71.779C86.5032 73.3038 85.2672 74.5398 83.7424 74.5398H55.2148C53.6901 74.5398 52.4541 73.3038 52.4541 71.779Z",
    fill: "#F7F7F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4541 244.785C52.4541 243.26 53.6901 242.024 55.2148 242.024H83.7424C85.2672 242.024 86.5032 243.26 86.5032 244.785C86.5032 246.31 85.2672 247.546 83.7424 247.546H55.2148C53.6901 247.546 52.4541 246.31 52.4541 244.785Z",
    fill: "#F7F7F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4541 289.877C52.4541 288.353 53.6901 287.117 55.2148 287.117H83.7424C85.2672 287.117 86.5032 288.353 86.5032 289.877C86.5032 291.402 85.2672 292.638 83.7424 292.638H55.2148C53.6901 292.638 52.4541 291.402 52.4541 289.877Z",
    fill: "#F7F7F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8467 201.534C24.8467 200.009 26.0827 198.773 27.6074 198.773H56.135C57.6597 198.773 58.8958 200.009 58.8958 201.534C58.8958 203.058 57.6597 204.294 56.135 204.294H27.6074C26.0827 204.294 24.8467 203.058 24.8467 201.534Z",
    fill: "#F7F7F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8223 115.031C82.8223 113.506 84.0583 112.27 85.583 112.27H114.111C115.635 112.27 116.871 113.506 116.871 115.031C116.871 116.555 115.635 117.791 114.111 117.791H85.583C84.0583 117.791 82.8223 116.555 82.8223 115.031Z",
    fill: "#F7F7F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.43 158.282C110.43 156.758 111.666 155.521 113.19 155.521H141.718C143.243 155.521 144.479 156.758 144.479 158.282C144.479 159.807 143.243 161.043 141.718 161.043H113.19C111.666 161.043 110.43 159.807 110.43 158.282Z",
    fill: "#F7F7F7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.988 71.3189C103.988 74.1142 101.722 76.3803 98.9266 76.3803C96.1313 76.3803 93.8652 74.1142 93.8652 71.3189C93.8652 68.5236 96.1313 66.2576 98.9266 66.2576C101.722 66.2576 103.988 68.5236 103.988 71.3189Z",
    fill: "#F7F7F7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.988 244.325C103.988 247.12 101.722 249.386 98.9266 249.386C96.1313 249.386 93.8652 247.12 93.8652 244.325C93.8652 241.53 96.1313 239.264 98.9266 239.264C101.722 239.264 103.988 241.53 103.988 244.325Z",
    fill: "#F7F7F7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.988 289.417C103.988 292.213 101.722 294.479 98.9266 294.479C96.1313 294.479 93.8652 292.213 93.8652 289.417C93.8652 286.622 96.1313 284.356 98.9266 284.356C101.722 284.356 103.988 286.622 103.988 289.417Z",
    fill: "#F7F7F7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3805 201.074C76.3805 203.869 74.1145 206.135 71.3192 206.135C68.5239 206.135 66.2578 203.869 66.2578 201.074C66.2578 198.278 68.5239 196.012 71.3192 196.012C74.1145 196.012 76.3805 198.278 76.3805 201.074Z",
    fill: "#F7F7F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3805 114.571C76.3805 117.366 74.1145 119.632 71.3192 119.632C68.5239 119.632 66.2578 117.366 66.2578 114.571C66.2578 111.775 68.5239 109.509 71.3192 109.509C74.1145 109.509 76.3805 111.775 76.3805 114.571Z",
    fill: "#F7F7F7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M103.988 157.822C103.988 160.617 101.722 162.883 98.9266 162.883C96.1313 162.883 93.8652 160.617 93.8652 157.822C93.8652 155.027 96.1313 152.761 98.9266 152.761C101.722 152.761 103.988 155.027 103.988 157.822Z",
    fill: "#F7F7F7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0859 62.5766C22.0859 61.5601 22.91 60.7361 23.9264 60.7361H41.4111C42.4276 60.7361 43.2516 61.5601 43.2516 62.5766V80.0612C43.2516 81.0777 42.4276 81.9017 41.4111 81.9017H23.9264C22.91 81.9017 22.0859 81.0777 22.0859 80.0612V62.5766Z",
    fill: "#F7F7F7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1731 69.7985C39.2144 69.7985 40.0585 68.9544 40.0585 67.9131C40.0585 66.8717 39.2144 66.0276 38.1731 66.0276C37.1318 66.0276 36.2876 66.8717 36.2876 67.9131C36.2876 68.9544 37.1318 69.7985 38.1731 69.7985ZM31.9891 70.6397C32.3433 70.0262 33.2288 70.0262 33.583 70.6397L36.4211 75.5556C36.7753 76.1691 36.3326 76.9359 35.6242 76.9359H30.8988C30.7615 77.0204 30.5982 77.0702 30.4176 77.0702H27.074C26.3656 77.0702 25.9228 76.3033 26.277 75.6898L27.9488 72.7942C28.303 72.1807 29.1885 72.1807 29.5427 72.7942L30.144 73.8355L31.9891 70.6397Z",
    fill: "#BDBDBD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0859 235.583C22.0859 234.566 22.91 233.742 23.9264 233.742H41.4111C42.4276 233.742 43.2516 234.566 43.2516 235.583V253.067C43.2516 254.084 42.4276 254.908 41.4111 254.908H23.9264C22.91 254.908 22.0859 254.084 22.0859 253.067V235.583Z",
    fill: "#F7F7F7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1731 242.805C39.2144 242.805 40.0585 241.96 40.0585 240.919C40.0585 239.878 39.2144 239.034 38.1731 239.034C37.1318 239.034 36.2876 239.878 36.2876 240.919C36.2876 241.96 37.1318 242.805 38.1731 242.805ZM31.9891 243.646C32.3433 243.032 33.2288 243.032 33.583 243.646L36.4211 248.562C36.7753 249.175 36.3326 249.942 35.6242 249.942H30.8988C30.7615 250.026 30.5982 250.076 30.4176 250.076H27.074C26.3656 250.076 25.9228 249.309 26.277 248.696L27.9488 245.8C28.303 245.187 29.1885 245.187 29.5427 245.8L30.144 246.842L31.9891 243.646Z",
    fill: "#BDBDBD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0859 280.675C22.0859 279.658 22.91 278.834 23.9264 278.834H41.4111C42.4276 278.834 43.2516 279.658 43.2516 280.675V298.16C43.2516 299.176 42.4276 300 41.4111 300H23.9264C22.91 300 22.0859 299.176 22.0859 298.16V280.675Z",
    fill: "#F7F7F7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1731 287.897C39.2144 287.897 40.0585 287.053 40.0585 286.011C40.0585 284.97 39.2144 284.126 38.1731 284.126C37.1318 284.126 36.2876 284.97 36.2876 286.011C36.2876 287.053 37.1318 287.897 38.1731 287.897ZM31.9891 288.738C32.3433 288.125 33.2288 288.125 33.583 288.738L36.4211 293.654C36.7753 294.267 36.3326 295.034 35.6242 295.034H30.8988C30.7615 295.119 30.5982 295.169 30.4176 295.169H27.074C26.3656 295.169 25.9228 294.402 26.277 293.788L27.9488 290.893C28.303 290.279 29.1885 290.279 29.5427 290.893L30.144 291.934L31.9891 288.738Z",
    fill: "#BDBDBD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.073 105.828C126.073 104.812 126.897 103.988 127.914 103.988H145.398C146.415 103.988 147.239 104.812 147.239 105.828V123.313C147.239 124.329 146.415 125.153 145.398 125.153H127.914C126.897 125.153 126.073 124.329 126.073 123.313V105.828Z",
    fill: "#F7F7F7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.16 113.05C143.202 113.05 144.046 112.206 144.046 111.165C144.046 110.123 143.202 109.279 142.16 109.279C141.119 109.279 140.275 110.123 140.275 111.165C140.275 112.206 141.119 113.05 142.16 113.05ZM135.976 113.891C136.331 113.278 137.216 113.278 137.57 113.891L140.408 118.807C140.763 119.421 140.32 120.187 139.611 120.187H134.886C134.749 120.272 134.586 120.322 134.405 120.322H131.061C130.353 120.322 129.91 119.555 130.264 118.941L131.936 116.046C132.29 115.432 133.176 115.432 133.53 116.046L134.131 117.087L135.976 113.891Z",
    fill: "#BDBDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 551,
    height: 298,
    rx: 9,
    stroke: "#F7F7F7",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M181 14.5215C181 11.472 183.472 9 186.521 9H306.153C309.203 9 311.675 11.472 311.675 14.5215V90.356C311.675 93.4054 309.203 95.8774 306.153 95.8774H186.521C183.472 95.8774 181 93.4054 181 90.356L181 14.5215Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.465 13.7234H186.535C185.516 13.7234 184.69 14.7808 184.69 16.0852V117.915C184.69 119.219 185.516 120.277 186.535 120.277C187.554 120.277 306.465 120.277 306.465 120.277C307.484 120.277 308.31 119.219 308.31 117.915V16.0852C308.31 14.7808 307.484 13.7234 306.465 13.7234ZM186.535 9C183.478 9 181 12.1721 181 16.0852V117.915C181 121.828 183.478 125 186.535 125H306.465C309.522 125 312 121.828 312 117.915V16.0852C312 12.1721 309.522 9 306.465 9H186.535Z",
    fill: "#F7F7F7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.564 22.8037L246.337 22.8037L246.337 36.6074L197.564 36.6074L197.564 22.8037Z",
    fill: "#F7F7F7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M259.439 29.8154C259.439 31.6549 257.948 33.146 256.109 33.146C254.269 33.146 252.778 31.6549 252.778 29.8154C252.778 27.976 254.269 26.4849 256.109 26.4849C257.948 26.4849 259.439 27.976 259.439 29.8154Z",
    fill: "#F7F7F7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184 48C184 46.8954 184.895 46 186 46H308C309.105 46 310 46.8954 310 48V120C310 121.105 309.105 122 308 122H186C184.895 122 184 121.105 184 120V48Z",
    fill: "#F7F7F7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M197.612 64.4845C197.614 63.4681 198.44 62.6458 199.456 62.6479L293.27 62.8457C294.287 62.8479 295.109 63.6736 295.107 64.6901L295.063 85.2315C295.061 86.2479 294.236 87.0702 293.219 87.0681L199.405 86.8703C198.389 86.8681 197.566 86.0424 197.569 85.0259L197.612 64.4845Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.199 74.074C225.199 72.5493 226.435 71.3132 227.96 71.3132H244.844C246.369 71.3132 247.605 72.5493 247.605 74.074C247.605 75.5987 246.369 76.8347 244.844 76.8347H227.96C226.435 76.8347 225.199 75.5987 225.199 74.074Z",
    fill: "#F7F7F7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M300 70C300 76.6274 294.627 82 288 82C281.373 82 276 76.6274 276 70C276 63.3726 281.373 58 288 58C294.627 58 300 63.3726 300 70Z",
    fill: "#333333"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M259.11 74.7153C259.11 76.5548 257.619 78.0459 255.78 78.0459C253.94 78.0459 252.449 76.5548 252.449 74.7153C252.449 72.8759 253.94 71.3848 255.78 71.3848C257.619 71.3848 259.11 72.8759 259.11 74.7153Z",
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.649 69.6555C291.649 71.495 290.158 72.9861 288.318 72.9861C286.479 72.9861 284.988 71.495 284.988 69.6555C284.988 67.8161 286.479 66.325 288.318 66.325C290.158 66.325 291.649 67.8161 291.649 69.6555Z",
    fill: "#333333"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M205.216 69.5917C205.216 68.5752 206.04 67.7512 207.056 67.7512H217.303C218.32 67.7512 219.144 68.5752 219.144 69.5917V79.8386C219.144 80.8551 218.32 81.6791 217.303 81.6791H207.056C206.04 81.6791 205.216 80.8551 205.216 79.8386V69.5917Z",
    fill: "#F7F7F7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.802 73.7148C216.487 73.7148 217.043 73.1594 217.043 72.4741C217.043 71.7889 216.487 71.2334 215.802 71.2334C215.117 71.2334 214.561 71.7889 214.561 72.4741C214.561 73.1594 215.117 73.7148 215.802 73.7148ZM211.46 74.7406C211.814 74.1271 212.7 74.1271 213.054 74.7406L214.377 77.0314C214.731 77.6449 214.288 78.4118 213.58 78.4118H210.935C210.829 78.4118 210.73 78.3948 210.638 78.3639C210.5 78.4496 210.335 78.5002 210.153 78.5002H209.043C208.335 78.5002 207.892 77.7333 208.246 77.1198L208.801 76.1584C209.156 75.5449 210.041 75.5449 210.395 76.1584L210.518 76.3718L211.46 74.7406Z",
    fill: "#BDBDBD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.595 51.6011C311.578 51.6011 310.754 52.4251 310.754 53.4416V65.6201L304.312 69.5458L310.754 73.4716V140.865C310.754 141.881 311.578 142.705 312.595 142.705H453.392C454.409 142.705 455.233 141.881 455.233 140.865V53.4416C455.233 52.4251 454.409 51.6011 453.392 51.6011H312.595Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.312 69.546L310.754 65.6202V53.4417C310.754 52.4252 311.578 51.6012 312.595 51.6012H453.392C454.409 51.6012 455.233 52.4252 455.233 53.4417V140.865C455.233 141.882 454.409 142.706 453.392 142.706H312.595C311.578 142.706 310.754 141.882 310.754 140.865V73.4717L304.312 69.546ZM306.153 76.056V140.865C306.153 144.423 309.037 147.307 312.595 147.307H453.392C456.95 147.307 459.834 144.423 459.834 140.865V53.4417C459.834 49.8841 456.95 47 453.392 47H312.595C309.037 47 306.153 49.8841 306.153 53.4417V63.036L295.471 69.546L306.153 76.056Z",
    fill: "#333333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 281.988,
    y: 64.325,
    width: 12.6612,
    height: 12.6612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 299.312,
    y: 49.6011,
    width: 160.92,
    height: 101.104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.423529 0 0 0 0 0.427451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2NdStepGray);
export default __webpack_public_path__ + "static/media/2nd-step_gray.1ae3a9c09c70feaba27fd1ce9c6f49cc.svg";
export { ForwardRef as ReactComponent };